<div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;">
    <div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
        <div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0">
        </div>
    </div>
    <div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
        <div style="position:absolute;width:200%;height:200%;left:0; top:0">
        </div>
    </div>
</div>
<div class="legend-wrapper">
  <div class="legend-box">
    <div id="chart-legends-bar" class="chart-legend-custom">
      <ul>
        @for (item of legends; track $index) {
          <li>
            <div class="chart-bar-legend">
              <span class="chart-bar-color" [style.backgroundColor]="item.color"></span>
              <span class="chart-bar-value" [style.color]="item.color">{{item.text}}</span>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
<canvas #chartHost width="465" height="101" class="chartjs-render-monitor" style="display: block; width: 465px; height: 101px;"></canvas>
